<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1 class="fs-2 fw-light">My Complaints</h1>
    <div class="d-flex gap-2">
      @if (!isCreateMode) {
        <button (click)="onCreateComplaint()" type="button" class="btn btn-success">
          <fa-icon [icon]="faPaperPlane"></fa-icon> New Complaint
        </button>
      }
      <button (click)="goHome()" type="button" class="btn btn-primary">
        <fa-icon [icon]="faHomeAlt"></fa-icon> Home
      </button>
    </div>
  </div>

  @if (loading) {
    <div class="d-flex justify-content-center my-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  } @else {
    @if (isCreateMode) {
      <div class="card mb-4">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0">Create New Complaint</h5>
          <button (click)="onCancelCreate()" type="button" class="btn btn-sm btn-outline-secondary">
            <fa-icon [icon]="faX"></fa-icon> Close
          </button>
        </div>
        <div class="card-body">
          <form [formGroup]="createComplaintForm">
            <div class="row">
              <div class="col-md-6 form-group my-2">
                <label class="form-label" for="complainantName">Your Name</label>
                <input class="form-control" id="complainantName" type="text" formControlName="name_complainant" [ngClass]="{ 'is-invalid': submitComplaintData && fcf.name_complainant.errors }" />
              </div>
              <div class="col-md-6 form-group my-2">
                <label class="form-label" for="complainantEmail">Your Email</label>
                <input class="form-control" id="complainantEmail" type="email" formControlName="complainant_email" [ngClass]="{ 'is-invalid': submitComplaintData && fcf.complainant_email.errors }" />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group my-2">
                <label class="form-label" for="complainantAddress">Your Address</label>
                <input class="form-control" id="complainantAddress" type="text" formControlName="address_complainant" [ngClass]="{ 'is-invalid': submitComplaintData && fcf.address_complainant.errors }" />
              </div>
              <div class="col-md-6 form-group my-2">
                <label class="form-label" for="complainantType">Type</label>
                <input class="form-control" id="complainantType" type="text" formControlName="complainant_type" placeholder="e.g., Resident, Tenant" [ngClass]="{ 'is-invalid': submitComplaintData && fcf.complainant_type.errors }" />
              </div>
            </div>

            <div class="form-group my-2">
              <label class="form-label" for="complainantLotNo">Your Unit/Lot Number</label>
              <input class="form-control" id="complainantLotNo" type="text" formControlName="complainant_section_strata_lotno" [ngClass]="{ 'is-invalid': submitComplaintData && fcf.complainant_section_strata_lotno.errors }" readonly />
            </div>

            <hr class="my-4" />

            <div class="row">
              <div class="col-md-6 form-group my-2">
                <label class="form-label" for="complaineeName">Complaint Against Name</label>
                <input class="form-control" id="complaineeName" type="text" formControlName="name_complainee" placeholder="Name of the person/entity" [ngClass]="{ 'is-invalid': submitComplaintData && fcf.name_complainee.errors }" />
              </div>
              <div class="col-md-6 form-group my-2">
                <label class="form-label" for="complaineeEmail">Email Address</label>
                <input class="form-control" id="complaineeEmail" type="email" formControlName="complainee_email" [ngClass]="{ 'is-invalid': submitComplaintData && fcf.complainee_email.errors }" />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group my-2">
                <label class="form-label" for="complaineeAddress">Address</label>
                <input class="form-control" id="complaineeAddress" type="text" formControlName="address_complainee" [ngClass]="{ 'is-invalid': submitComplaintData && fcf.address_complainee.errors }" />
              </div>
              <div class="col-md-6 form-group my-2">
                <label class="form-label" for="complaineeLotNo">Unit/Lot Number</label>
                <input class="form-control" id="complaineeLotNo" type="text" formControlName="complainee_section_strata_lotno" [ngClass]="{ 'is-invalid': submitComplaintData && fcf.complainee_section_strata_lotno.errors }" />
              </div>
            </div>

            <hr class="my-4" />

            <div class="form-group my-3">
              <label class="form-label" for="groundsComplaint">Grounds of Complaint</label>
              <textarea class="form-control" id="groundsComplaint" rows="5" formControlName="grounds_complaint" placeholder="Describe the complaint in detail" [ngClass]="{ 'is-invalid': submitComplaintData && fcf.grounds_complaint.errors }"></textarea>
            </div>

            <div class="form-group my-2">
              <label class="form-label" for="dateSubmission">Date of Submission</label>
              <input class="form-control" id="dateSubmission" type="date" formControlName="date_submission" [ngClass]="{ 'is-invalid': submitComplaintData && fcf.date_submission.errors }" readonly />
            </div>

            <input type="hidden" formControlName="propertyId" />
          </form>
        </div>
        <div class="card-footer d-flex justify-content-between">
          <button (click)="onCancelCreate()" type="button" class="btn btn-secondary">
            Cancel
          </button>
          <button (click)="submitCreateComplaint()" type="button" class="btn btn-success" [disabled]="fetching">
            @if (fetching) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            }
            Submit Complaint
          </button>
        </div>
      </div>
    }

    <div class="mb-4">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            [class.active]="activeTab === 'complainant'"
            (click)="setActiveTab('complainant')"
            type="button"
            role="tab"
            aria-selected="activeTab === 'complainant'"
          >
            My Complaints
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            [class.active]="activeTab === 'complainee'"
            (click)="setActiveTab('complainee')"
            type="button"
            role="tab"
            aria-selected="activeTab === 'complainee'"
          >
            Complaint Reports
          </button>
        </li>
      </ul>
    </div>

    @if (activeTab === 'complainant') {
      <div class="tab-content">
        <div class="input-group mb-3">
          <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
          <input
            type="text"
            name="searchComplaint"
            [(ngModel)]="searchQuery"
            class="form-control"
            placeholder="Search complaints..."
          />
        </div>

        @if (filteredMyComplaints.length === 0) {
          <div class="alert alert-info">
            @if (searchQuery) {
              No complaints match your search.
            } @else {
              No complaints found.
            }
          </div>
        } @else {
          <div class="list-group">
            @for (complaint of filteredMyComplaints; track complaint.id) {
              <div class="list-group-item">
                <div class="d-flex w-100 justify-content-between">
                  <h6 class="mb-1">
                    Against: <strong>{{ complaint.name_complainee }}</strong>
                  </h6>
                  <small>{{ complaint.date_submission | date: 'MMM d, y' }}</small>
                </div>
                <p class="mb-1 text-secondary small">{{ complaint.grounds_complaint }}</p>
                <div class="text-secondary small mt-2">
                  Status: <strong>{{ getComplaintStatusLabel(complaint.status) }}</strong> |
                  Lot: {{ complaint.complainant_section_strata_lotno }}
                </div>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (activeTab === 'complainee') {
      <div class="tab-content">
        <div class="input-group mb-3">
          <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
          <input
            type="text"
            name="searchReports"
            [(ngModel)]="searchQuery"
            class="form-control"
            placeholder="Search complaint reports..."
          />
        </div>

        @if (filteredComplaintReports.length === 0) {
          <div class="alert alert-info">
            @if (searchQuery) {
              No complaint reports match your search.
            } @else {
              No complaint reports found.
            }
          </div>
        } @else {
          <div class="list-group">
            @for (complaint of filteredComplaintReports; track complaint.id) {
              <div class="list-group-item">
                <div class="d-flex w-100 justify-content-between">
                  <h6 class="mb-1">
                    From: <strong>{{ complaint.name_complainant }}</strong>
                  </h6>
                  <small>{{ complaint.date_submission | date: 'MMM d, y' }}</small>
                </div>
                <p class="mb-1 text-secondary small">{{ complaint.grounds_complaint }}</p>
                <div class="text-secondary small mt-2">
                  Status: <strong>{{ getComplaintStatusLabel(complaint.status) }}</strong> |
                  Lot: {{ complaint.complainee_section_strata_lotno }}
                </div>
              </div>
            }
          </div>
        }
      </div>
    }

    <div class="mt-4">
      <button (click)="goBack()" type="button" class="btn btn-secondary">
        <fa-icon [icon]="faCircleArrowLeft"></fa-icon> Back
      </button>
    </div>
  }
</div>
